<template>
    <l-layout :layout="['xs12']">
      <l-data-table
      :headers="header"
      :get-data-func="getTempSignList"
      :filter-items="filter"
      search-text="请输入用户姓名"
      hide-title-search>
        <template slot="title">
          <span class="pl-2 pr-4">进校登记日志</span>
          <v-btn flat color="primary"  :loading="loading" @click="outputExcel_2">导出excel</v-btn>
        </template>
      </l-data-table>
    </l-layout>
</template>

<script>
    import LDataTable from "../../../ladmin/components/LDataTable/LDataTable"
    import {time} from '../../../ladmin/utils/time'
    import { exportExcel } from 'xlsx-oc'
    function passStatusMap(v) {
      if(v===''||v===null){
        return 'N/A'
      }
      switch (v+'') {
        case '0':return '申请授权';
        case '1':return '轮班授权';
        case '2':return '白名单授权';
        case '3':return '黑名单授权;'
      }
      return 'N/A'
    }
    function inOrOutMap(v) {
      if(v===''||v===null){
        return 'N/A'
      }
      switch (v+'') {
        case '0':return '入校';
        case '1':return '出校';
      }
      return 'N/A'
    }
    export default {
        name: "tempSignList",
      components: {LDataTable},
      data(){
          return {
            header:[
              {text:'所在校区',value:'park',align:'left',sortable:false},
              {text:'登记卡口',value:'controller',align:'left',sortable:false},
              {text:'进出类型',value:'inOrOut',align:'left',sortable:false,f:(v)=>inOrOutMap(v)},
              {text:"登记时间",value:'passTimeServer',align:'left',sortable:false,},
              {text:"用户姓名",value:'name',align:'left',sortable:false,},
              {text:"用户账号",value:'loginId',align:'left',sortable:false,},
              {text:"手机号码",value:'phone',align:'left',sortable:false,},
              {text:"所在单位",value:'orgName',align:'left',sortable:false,tooltip:true,maxWidth:'6em'},
              {text:"登记类型",value:'authType',align:'left',sortable:false,},
              {text:"授权类型",value:'auditType',align:'left',sortable:false,f:(v)=>passStatusMap(v)},
              {text:"通行描述",value:'passStatus',align:'left',sortable:false,tooltip:true,maxWidth:'11em'},
            ],
            filter: [
              {
                key: 'passTimeDuration',
                value: {},
                label: '通行时间',
                type: 'duration',
                layout: ['xs12', 'sm4'],
                f: v => v ? [time.toTimeStamp(v.startDatetime) || 0, time.toTimeStamp(v.endDatetime) || 9999999999999] : [0, 9999999999999],
                range: true
              },
              {
                prependIcon: '$vuetify.icons.person',
                key: 'name',
                value: '',
                label: '用户姓名',
                type: 'input',
                layout: ['xs12', 'sm4'],
              },
              {
                prependIcon: '$vuetify.icons.person',
                key: 'loginId',
                value: '',
                label: '用户账号',
                type: 'input',
                layout: ['xs12', 'sm4'],
              },
              {
                prependIcon: '$vuetify.icons.phone',
                key: 'phone',
                value: '',
                label: '手机号码',
                type: 'input',
                layout: ['xs12', 'sm4'],
              },
            ],
            fileName:"进校登记记录表.xlsx",
            fileHeader:[
              { k: 'park', v: '通行校区' },
              { k: 'controller', v: '通行卡口' },
              { k: 'inOrOut', v: '出入类型' },
              { k: 'passTimeServer', v: '通行时间' },
              { k: 'name', v: '用户姓名' },
              { k: 'loginId', v: '用户账号' },
              { k: 'phone', v: '手机号码' },
              { k: 'orgName', v: '所在单位' },
              { k: 'authType', v: '登记类型'},
              { k: 'passStatus', v: '通行结果'},
              { k: 'auditType', v: '授权类型'},
            ],
            loading:false,
            amount:0
          }
      },
      methods:{
        async getTempSignList({pagination, sortStack, filterItems, search}){
          let params = this.dealParams(filterItems)
          let res = await this.$store.dispatch('wx/getTempSelfSignList',{pagination,params:params})
          let items = res.items
          for(let i=0;i<items.length;i++){
              if(items[i].controllerId===""||items[i].controllerId==="undefined"){
                items[i].park = "N/A"
                items[i].controller = "N/A"
              }
              else{
                let c =  this.getController(items[i].controllerId)
                if(c!==null){
                  items[i].park = c.parkingLot.name
                  items[i].controller = c.name
                  items[i].inOrOut = c.inOrOut
                }else{
                  items[i].park = "N/A"
                  items[i].controller = "N/A"
                  items[i].inOrOut = ""
                }
              }
              let self = this.dealUserInfo(JSON.parse(items[i].userInfo))
              items[i].name = self.name
              items[i].loginId = self.loginId
              items[i].phone = self.phone
              items[i].orgName = self.orgName
              items[i].authType = self.authType
          }
          this.amount = res.amount
          return {items:items,amount:res.amount}
        },
        dealParams(filterItems){
          console.log(filterItems)
          let searchParam = {
              'searchParam': {
                'loginId': {
                  'operators':[
                    {'keyword': filterItems[2].value,operator:'LIKE'}
                  ],
                  'order': 'NONE',
                  'index':0
                },
                'creationTime': {
                  'order': 'DESC',
                  'operators':[
                      {
                        'keyword':(filterItems[0].value.startDatetime===undefined||filterItems[0].value.startDatetime===null)?'0':time.toTimeStamp(filterItems[0].value.startDatetime),
                        'operator':'GTE'
                      },
                      {
                        'keyword':(filterItems[0].value.endDatetime===undefined||filterItems[0].value.endDatetime===null)?"9999999999999":time.toTimeStamp(filterItems[0].value.endDatetime),
                        'operator':'LTE'
                      },
                    ],
                  'index':2
                },
                'userInfo': {
                  'order': 'NONE',
                  'operators':[
                    {
                      'keyword':filterItems[1].value,
                      'operator':'LIKE'
                    },
                    {
                      'keyword':filterItems[3].value,
                      'operator':'LIKE'
                    },
                  ],
                  'index':1
                }
              },
          }
          return searchParam
        },
        dealUserInfo(data){
          //console.log(data)
          let self = {
            name:'N/A',
            loginId:'N/A',
            phone:'N/A',
            orgName:'N/A',
            authType:'N/A'
          }
          if(data.selfConfig===undefined){
            self.name = data.userInfo.name
            self.loginId = data.userInfo.loginId
            self.phone = data.userInfo.mobilePhone
            return self
          }
          if(data.selfConfig.currentReg === undefined){
            self.name = data.userInfo.name
            self.loginId = data.userInfo.loginId
            self.phone = data.userInfo.mobilePhone
            self.orgName = data.selfConfig.currentOrg === undefined?'N/A':data.selfConfig.currentOrg.name
          }else{
            let extend = data.userInfo.extend===undefined?{}:JSON.parse(data.userInfo.extend)
            if(extend.name!==undefined){
              self.name = extend.name
              self.orgName = extend.orgName
              self.loginId = data.userInfo.mobilePhone
              self.phone = data.userInfo.mobilePhone
            }else{
              self.name = data.userInfo.name
              self.orgName = data.selfConfig.currentOrg===undefined?"N/A":(data.selfConfig.currentOrg.name||'N/A')
              self.loginId = data.userInfo.loginId
              self.phone = data.userInfo.mobilePhone
            }
            let reg = data.selfConfig.currentReg
            if(reg.name === "【登记】注册访客"){
              if(extend.name!==undefined){
                self.authType = "【临时】特勤访客"
              }else{
                self.authType = "访客"
              }
            }else{
              self.authType = reg.name
            }
          }
          return self
        },
        getController(id){
          let controllerList = this.$store.state.parkingLot.unDirControllerList
          let dirControllerList = this.$store.state.parkingLot.personControllerList
          //console.log(controllerList)
          for(let i=0;i<controllerList.length;i++){
            if(controllerList[i].id === id){
              let dir = controllerList[i].dirgateList
              if(dir == null||dir.length == 0){
                let res = controllerList[i]
                res.inOrOut = '0'
                res.parkingLot = {
                  name: controllerList[i].park && controllerList[i].park[0] && controllerList[i].park[0].name
                }
                return res
              }
              for(let j=0;j<dir.length;j++) {
                if (dir[j].passType == "0"&&dir[j].inOrOut == '0') {
                  dir[j].parkingLot = {
                    name: controllerList[i].park && controllerList[i].park[0] && controllerList[i].park[0].name
                  }
                  dir[j].name = controllerList[i].name||'N/A'
                  return dir[j]
                }
              }
            }
          }
          for(let i=0;i<dirControllerList.length;i++){
            if(dirControllerList[i].id === id){
              dirControllerList[i].name = dirControllerList[i].gateInfo.name||'N/A'
              return dirControllerList[i]
            }
          }
          return null
        },
        async outputExcel(){
          let pagination = {
            page:1,
            rowsPerPage: this.amount
          }
          let params = this.dealParams(this.filter)
          this.loading = true
          let res = await this.$store.dispatch('wx/getTempSelfSignList',{pagination,params:params})
          let list = []
          let items = res.items
          for(let i=0;i<items.length;i++){
            if(items[i].controllerId===""||items[i].controllerId==="undefined"){
              items[i].park = "N/A"
              items[i].controller = "N/A"
              items[i].inOrOut = inOrOutMap("")
            }
            else{
              let c =  this.getController(items[i].controllerId)
              if(c!==null){
                items[i].park = c.parkingLot.name
                items[i].controller = c.name
                items[i].inOrOut = inOrOutMap(c.inOrOut)
              }else{
                items[i].park = "N/A"
                items[i].controller = "N/A"
                items[i].inOrOut = inOrOutMap("")
              }
            }
            let self = this.dealUserInfo(JSON.parse(items[i].userInfo))
            items[i].name = self.name
            items[i].loginId = self.loginId
            items[i].phone = self.phone
            items[i].orgName = self.orgName
            items[i].authType = self.authType
          }
          list = items
          if(list.length === 0){
            this.$L.alert('error',{message:'未查询到数据无法导出'})
          }else{
            exportExcel(this.fileHeader, list, this.fileName)
          }
          this.loading = false
        },
        async outputExcel_2(){
          let pagination = {
            page:1,
            rowsPerPage: this.amount
          }
          let params = this.dealParams(this.filter)
          this.loading = true
          let res = await this.$store.dispatch('wx/getTempSelfSignList',{pagination,params:params})
          let list = []
          let items = res.items
          for(let i=0;i<items.length;i++){
            if(items[i].controllerId===""||items[i].controllerId==="undefined"){
              items[i].park = "N/A"
              items[i].controller = "N/A"
              items[i].inOrOut = inOrOutMap("")
            }
            else{
              let c =  this.getController(items[i].controllerId)
              if(c!==null){
                items[i].park = c.parkingLot.name
                items[i].controller = c.name
                items[i].inOrOut = inOrOutMap(c.inOrOut)
              }else{
                items[i].park = "N/A"
                items[i].controller = "N/A"
                items[i].inOrOut = inOrOutMap("")
              }
            }
            let self = this.dealUserInfo(JSON.parse(items[i].userInfo))
            items[i].name = self.name
            items[i].loginId = self.loginId
            items[i].phone = self.phone
            items[i].orgName = self.orgName
            items[i].authType = self.authType
          }
          const ExportJsonExcel = require('js-export-excel')
          let option = {}
          items.forEach((item)=>{
            let arr = []
            for(let i in this.fileHeader){
              arr.push(item[this.fileHeader[i].k])
            }
            list.push(arr)
          })
          //console.log(list)
          option.fileName = "进校登记记录表"
          option.datas=[
            {
              sheetData:list,
              sheetName:'sheet',
              sheetHeader:['通行校区','通行卡口','通行时间','出入类型','用户姓名','用户账号','手机号码','所在单位','登记类型','通行结果','授权类型'],
            },
          ];
          let toExcel = new ExportJsonExcel(option); //new
          toExcel.saveExcel(); //保存
          this.loading = false
        }
      }
    }
</script>

<style scoped>

</style>
